// Типы действий флагов кабинета. Отдельный файл без импортов,
// чтобы редьюсер можно было проверить в Jest без axios.

// Первый ответ GET /api/ui/flags после открытия кабинета: меню и отметка обучения.
export const NAV_FLAGS_LOADED = "NAV_FLAGS_LOADED";

// Следующие ответы (фокус вкладки, смена магазина): меняют только canSeeReviews.
export const NAV_FLAGS_REFRESHED = "NAV_FLAGS_REFRESHED";

// Ответ GET /api/ui/nav-kill: payload — off (true или false).
export const NAV_KILL_CHECKED = "NAV_KILL_CHECKED";

// Человек прошёл или закрыл короткое обучение по меню.
export const NAV_TOUR_SEEN = "NAV_TOUR_SEEN";

// Кабинет закрыт (выход, переход на страницу вне кабинета).
export const NAV_FLAGS_RESET = "NAV_FLAGS_RESET";
